<template>
  <div class="td-money-component">
    <template v-if="order.status === 'PAY_CONFIRMED'">
      <p>实付金额</p>
      <span class="price">{{priceUnit}}{{order.orderRealPayPrice}}</span>
    </template>
    <template v-else>
      <p>应付金额</p>
      <span class="price">{{priceUnit}}{{order.realPayPrice}}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    priceUnit() {
      return this.order.currency === 'HKD' ? 'HKD ' : '¥'
    }
  }
}
</script>
